import { Types } from '@amplitude/analytics-browser';
import { stripLocationPrefix } from '../../shared/navbar/location-utils';

export function stripLocationNumberFromAnalyticsValue(value: string): string {
  if (/^https?:\/\//i.test(value)) {
    try {
      const url = new URL(value);
      url.pathname = stripLocationPrefix(url.pathname);
      return url.href;
    } catch {
      return value;
    }
  }

  if (value.startsWith('/')) {
    return stripLocationPrefix(value);
  }

  return value;
}

export function stripLocationNumberFromEventProperties(
  properties: Record<string, unknown> | undefined,
): Record<string, unknown> | undefined {
  if (!properties) {
    return properties;
  }

  Object.keys(properties).forEach((key) => {
    properties[key] = stripLocationNumberFromUnknown(properties[key]);
  });

  return properties;
}

function stripLocationNumberFromUnknown(value: unknown): unknown {
  if (typeof value === 'string') {
    return stripLocationNumberFromAnalyticsValue(value);
  }

  if (Array.isArray(value)) {
    return value.map((item) => stripLocationNumberFromUnknown(item));
  }

  if (value && typeof value === 'object') {
    return stripLocationNumberFromEventProperties(value as Record<string, unknown>);
  }

  return value;
}

export function createLocationPrefixEnrichmentPlugin(): Types.EnrichmentPlugin {
  return {
    name: 'strip-location-prefix',
    type: 'enrichment',
    execute: (event: Types.Event): Promise<Types.Event> => {
      stripLocationNumberFromEventProperties(
        event.event_properties as Record<string, unknown> | undefined,
      );
      return Promise.resolve(event);
    },
  };
}
